/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable jsx-a11y/heading-has-content */
/* eslint-disable no-script-url */
/* eslint-disable react/style-prop-object */

const SiteTemplate = (props) => {
return (
<html lang="en">

<head>
    <title id="site-title"></title>
    <meta name="description" content="NK Realtors" />
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <link rel="icon" href="https://microsite.nkrealtors.com/public/statics/images/nk.jpg" type="image/gif"
        sizes="16x16" />

    <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;500;600;700;800;900&display=swap"
        rel="stylesheet" />

    <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500;700;900&display=swap"
        rel="stylesheet" />
    <link href={`${props.serverURL}/public/statics/css/bootstrap.min.css`} rel="stylesheet" type="text/css" />
    <link href={`${props.serverURL}/public/statics/css/font-awesome.min.css`} rel="stylesheet" type="text/css" />
    <link href={`${props.serverURL}/public/statics/css/owl.carousel.min.css`} rel="stylesheet" />
    <link href={`${props.serverURL}/public/statics/css/owl.theme.default.min.css`} rel="stylesheet" />
    <link href={`${props.serverURL}/public/statics/css/jquery.fancybox.min.css`} rel="stylesheet" type="text/css" />
    <link href={`${props.serverURL}/public/statics/css/style.css`} rel="stylesheet" type="text/css" />

</head>

<body>
    <div id='loader' class="loader">
        <div class="loader-inner">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
    </div>
    <span id='serverURL' style={{ display: 'none' }}>{props.serverURL}</span>
    <span id='propertyID' style={{ display: 'none' }}>{props.id}</span>

    <header class="header fixed">
        <div class="container">
            <div class="nav-container">
                <div class="left-nav alt">
                    <a href="./" class="tab header-title" aria-label="Link">
                        <img src={`${props.serverURL}/public/statics/images/nk.jpg`} alt="" />
                    </a>
                </div>
                <div class="right-nav">
                    <div class="phone-dial d-none">
                        <a href="number:9830011551" aria-label="Link">
                            <i class="fa fa-phone" aria-hidden="true"></i>
                        </a>
                        <p>9 am to 8 pm IST)</p>
                    </div>
                    <div class="partner-logo">
                        <img id="partnerLogo" src={`${props.serverURL}/public/statics/images/test-logo.webp`}
                            class="img-fluid" alt="" />
                    </div>
                </div>
            </div>
        </div>
    </header>

    <section class="banner">
        <img id="bannerImage" src={`${props.serverURL}/public/statics/images/banner1.webp`} class="img-fluid" alt=""
            fetchpriority="high" decoding="async" />
    </section>
    <div class="slider-banner">
        <div class="container">
            <div class="row">
                <div class="col-lg-8">
                    <div class="title">
                        <h2 id="title"></h2>
                        <div id="description" class="subtitle"></div>
                        <ul>
                            <li>
                                <span>
                                    <i class="fa fa-map-marker"></i>
                                </span>
                                <p id="address"></p>
                            </li>
                        </ul>
                        <div class="price">
                            <span id="price"></span>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">
                    <form id="enquiry-form-upper" className="enquiry-form" name="myform" method="post">
                        <div className="head">
                            <p>Great choice Most liked project in this area</p>
                        </div>
                        <h3>Share your contact details!</h3>

                        <div className="form-group">
                            <input type="text" className="form-control shadow-none" name="fname" id="fname"
                                placeholder="Name" required />
                        </div>

                        <div className="form-group d-flex" style={{ gap: '5px' }}>
                            <input type="text" className="form-control shadow-none" name="countryCode" id="countryCode"
                                value="+91" style={{ width: '20%' , textAlign: 'center' }} required />
                            <input type="number" className="form-control shadow-none" name="phone" id="phone"
                                placeholder="Phone No." required />
                        </div>

                        <div className="form-group">
                            <input type="email" className="form-control shadow-none" name="email" id="email"
                                placeholder="Email Id" />
                        </div>

                        <div className="custom-control custom-checkbox">
                            <input type="checkbox" className="custom-control-input" id="customCheck1" defaultChecked />
                            <label className="custom-control-label" htmlFor="customCheck1">
                                I authorise NK Realtors &amp; its representatives to contact me with updates and
                                notifications via Email/SMS/WhatsApp/Call. This will override on DND/NDNC.
                                <a href="https://nkrealtors.com/privacy-policy/" aria-label="Link" style={{
                                    color: "#fff" }}>
                                    Know More
                                </a>
                            </label>
                        </div>

                        <p className="success-msg">Your response has been recorded</p>

                        <input type="button" className="btn footer-button" id="submit_btn" value="SUBMIT" />

                        <p id="demo"></p>
                    </form>
                </div>
            </div>
        </div>
    </div>

    <section class="project-overview p-60 lazy-section" id="overview">
        <div class="container">
            <div class="row">
                <div class="col-12 col-lg-6">
                    <div class="property-thumbnail">
                        <img id="overviewImage" src="" loading="lazy" class="img-fluid" alt="" />
                    </div>
                </div>
                <div class="col-12 col-lg-6">
                    <div class="project-desc">
                        <h2 id="overviewTitle"></h2>
                        <p id="overviewDescription"></p>
                        <ul>
                            <li>
                                <b>Property Type :</b>
                                <span id="propertyType"></span>
                            </li>
                            <li>
                                <b>Unit Size :</b>
                                <span id="unitSize"></span>
                            </li>
                            <li>
                                <b>No. of Units :</b>
                                <span id="numberOfUnits"></span>
                            </li>
                            <li>
                                <b>No. of Towers :</b>
                                <span id="numberOfTower"></span>
                            </li>
                            <li>
                                <b>No. of Floors :</b>
                                <span id="numberOfFloors"></span>
                            </li>
                            <li>
                                <b>Land Area :</b>
                                <span id="landArea"></span>
                            </li>
                            <li>
                                <b>Possession Year :</b>
                                <span id="possessionYear"></span>
                            </li>
                            <li>
                                <b>Possession Status :</b>
                                <span id="possessionStatus"></span>
                            </li>
                        </ul>
                        <button id='brochure-download' data-toggle="modal" data-target="#myModal"
                            class="btn-download">Download Brochure</button>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="why-choose p-60 lazy-section">
        <div class="container">
            <div class="row">
                <div class="col-12 col-lg-6">
                    <div class="head-title">
                        <h2 id="whyToChooseTitle" class="choose-title"></h2>
                    </div>
                    <div id="whyToChooseDescription" class="choose-description"></div>
                </div>
                <div class="col-12 col-lg-6">
                    <div class="choose-image">
                        <img id="whyToChooseImage" src="" loading="lazy" class="img-fluid" alt="" />
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="location p-60 lazy-section">
        <div class="container">
            <div class="head-title text-left mb-20">
                <h2 id="locationTitle"></h2>
                <p id="locationDescription"></p>
            </div>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="row">
                        <div class="col-lg-8">
                            <iframe id="mapUrl" src="" width="100%" height="400px" allowfullscreen="" loading="lazy"
                                referrerpolicy="no-referrer-when-downgrade" title="Map"></iframe>
                        </div>
                        <div class="col-lg-4">
                            <div class="accordion placesNearBy" id="accordionExample"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section id='floor-plan-section' class="floor-plan p-60 lazy-section">
        <div class="container">
            <div class="row">
                <div class="head-title text-center">
                    <h2 id="floorPlanTitle"></h2>
                    <p id="floorPlanDescription"></p>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="row">
                <div class="floor">
                    <ul id="units" class="nav nav-pills" role="tablist" aria-label="units"></ul>

                    <div id="floor-plans" class="tab-content"></div>
                </div>
            </div>
        </div>
    </section>

    <section class="amenities p-60 lazy-section">
        <div class="container">
            <div class="row">
                <div class="head-title text-center">
                    <h2 id="amenitiesTitle"></h2>
                    <p id="amenitiesDescription"></p>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="row">
                <ul id="amenities">
                </ul>
            </div>
        </div>
    </section>
    <section class="gallery pt-60 pb-30">
        <div class="container">
            <div class="row">
                <div class="head-title text-center mb-40">
                    <h2 id='gallery-title'></h2>
                    <p id='gallery-description'></p>
                </div>
            </div>
        </div>
        <div class="container-fluid">
            <div id="galleryImages" class="row"></div>
        </div>
    </section>

    <footer class="lazy-section">
        <div class="real-logo pt-10 pb-30 text-center">
            <div class="container">
                <img src={`${props.serverURL}/public/statics/images/nk.jpg`} class="foot-logo" alt="NK Realtors"
                    loading="lazy" />
            </div>
        </div>
        <div class="copyright p-30">
            <div class="container">
                <ul>
                    <li>
                        <p>
                            NK Realtors RERA Reg. No: WBRERA/RA/NOR/2023/000004 | <span id='hira'></span>
                        </p>
                    </li>
                </ul>
                <p class="mt-10 text-center">
			MSME Registration No : <b>UDYAM-WB-10-0182570</b>
                </p>
                <p class="mt-10 text-center">
                    &copy; 2025 - N.K. Realtors (P) Ltd. Powered By -
                    Bawandarr
                </p>
            </div>
        </div>
    </footer>

    <section id="section1">
        <div class="container">
            <div id="bottom-form" class="bottom-form">
                <div class="form-inline" name="myform3" method="post" action="javascript:void(0);">
                    <button class="close-btn mob-view" id='close-get-call-btn' aria-label="Close" onclick="hideDiv()">
                        <i class="fa fa-times" aria-hidden="true"></i>
                    </button>
                    <div class="form-group first-box">
                        <h5 style={{ color: "#fff" }}>GET IN TOUCH</h5>
                    </div>
                    <div class="form-group">
                        <input type="text" class="form-control shadow-none" id="name3" name="name3" placeholder="Name"
                            required="" />
                    </div>
                    <div class="form-group">
                        <input type="email" class="form-control shadow-none" id="email3" name="email3"
                            placeholder="Email" required="" />
                    </div>
                    <div className="form-group" style={{display: 'grid', gap: '0px', gridTemplateColumns: '3fr 12fr', marginRight: '5px' }}>
                        <input type="text" className="form-control shadow-none" name="countryCode3" id="countryCode3"
                            value="+91" style={{ padding: '0px' , textAlign: 'center' }} required />
                        <input type="number" className="form-control shadow-none" name="phone3" id="phone3"
                            placeholder="Phone No." required />
                    </div>
                    <div class="form-group">
                        <button type="button" id="bottom-form-submit-btn" class="btn footer-button">
                            SUBMIT
                        </button>
                    </div>
                    <p id="thankyou3">
                        Your form submission is under process - Please wait
                    </p>
                </div>
            </div>
        </div>
    </section>
    <div class="footer-btn">
        <div class="">
            <button id='get-call-btn' class="mob-view btn submit-btn">
                Get a call
            </button>
        </div>
    </div>
    <div class="modal fade mymodal" id="myModal" role="dialog">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="form-slider-wrapper">
                        <button id='modal-close-btn' class="close-btn" data-dismiss="modal" aria-label="Close">
                            <i class="fa fa-times" aria-hidden="true"></i>
                        </button>
                        <h3>Share your details to</h3>
                        <hr />
                        <form class="form" name="myform4" method="post">
                            <div class="form-group">
                                <label for="name">Your Name<em>*</em></label>
                                <input type="text" class="form-control" id="name4" name="name4" placeholder="Name"
                                    required="" />
                            </div>
                            <div className="form-group">
                                <label for="phone">Your Phone<em>*</em></label>
				<div class="d-flex" style={{ gap: '5px' }}>
                                <input type="text" className="form-control shadow-none" name="countryCode4"
                                    id="countryCode4" value="+91" style={{ width: '20%' , textAlign: 'center' }}
                                    required />
                                <input type="number" className="form-control shadow-none" name="phone4" id="phone4"
                                    placeholder="Phone No." required />
                            </div>
                            </div>

                            <div class="form-group">
                                <label for="email">Your Email<em>*</em></label>
                                <input type="email" class="form-control" id="email4" name="email4" placeholder="Email"
                                    required="" />
                            </div>
                            <div class="form-group">
                                <div id="form-slider-status"></div>
                                <button type="button" id="brochure-submit-btn" class="btn submit-btn">
                                    SUBMIT
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade mymodal" id="myModalPageload" role="dialog" aria-label="myModalPageload">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="form-slider-wrapper">
                        <button id='modal-close-btn' class="close-btn" data-dismiss="modal" aria-label="Close">
                            <i class="fa fa-times" aria-hidden="true"></i>
                        </button>
                        <h3>Share your details to</h3>
                        <hr />
                        <form class="form" name="myform5" method="post">
                            <div class="form-group">
                                <label for="name">Your Name<em>*</em></label>
                                <input type="text" class="form-control" id="name5" name="name5" placeholder="Name"
                                    required />
                            </div>
                            <div className="form-group">
                                <label for="phone">Your Phone<em>*</em></label>
				<div class="d-flex" style={{ gap: '5px' }}>
                                <input type="text" className="form-control shadow-none" name="countryCode5"
                                    id="countryCode5" value="+91" style={{ width: '20%' , textAlign: 'center' }}
                                    required />
                                <input type="number" className="form-control shadow-none" name="phone5" id="phone5"
                                    placeholder="Phone No." required />
                            </div>
                            </div>
                            <div class="form-group">
                                <label for="email">Your Email<em>*</em></label>
                                <input type="email" class="form-control" id="email5" name="email5" placeholder="Email"
                                    required />
                            </div>
                            <div class="form-group">
                                <div id="form-slider-status"></div>
                                <button type="button" id="pageload-submit-btn" class="btn submit-btn">
                                    SUBMIT
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>

	<a class="btn-whatsapp-pulse" href="https://wa.me/919830011551">
		<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24"><path fill="#fff" d="M19.05 4.91A9.816 9.816 0 0 0 12.04 2c-5.46 0-9.91 4.45-9.91 9.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21c5.46 0 9.91-4.45 9.91-9.91c0-2.65-1.03-5.14-2.9-7.01m-7.01 15.24c-1.48 0-2.93-.4-4.2-1.15l-.3-.18l-3.12.82l.83-3.04l-.2-.31a8.264 8.264 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.24-8.24c2.2 0 4.27.86 5.82 2.42a8.183 8.183 0 0 1 2.41 5.83c.02 4.54-3.68 8.23-8.22 8.23m4.52-6.16c-.25-.12-1.47-.72-1.69-.81c-.23-.08-.39-.12-.56.12c-.17.25-.64.81-.78.97c-.14.17-.29.19-.54.06c-.25-.12-1.05-.39-1.99-1.23c-.74-.66-1.23-1.47-1.38-1.72c-.14-.25-.02-.38.11-.51c.11-.11.25-.29.37-.43s.17-.25.25-.41c.08-.17.04-.31-.02-.43s-.56-1.34-.76-1.84c-.2-.48-.41-.42-.56-.43h-.48c-.17 0-.43.06-.66.31c-.22.25-.86.85-.86 2.07c0 1.22.89 2.4 1.01 2.56c.12.17 1.75 2.67 4.23 3.74c.59.26 1.05.41 1.41.52c.59.19 1.13.16 1.56.1c.48-.07 1.47-.6 1.67-1.18c.21-.58.21-1.07.14-1.18s-.22-.16-.47-.28"></path></svg>
	</a>


    <script src={`${props.serverURL}/public/statics/js/jquery.min.js`} type="text/javascript"></script>
    <script src={`${props.serverURL}/public/statics/js/popper.min.js`} type="text/javascript"></script>
    <script src={`${props.serverURL}/public/statics/js/bootstrap.min.js`} type="text/javascript"></script>
    <script src={`${props.serverURL}/public/statics/js/owl.carousel.min.js`} type="text/javascript"></script>
    <script src={`${props.serverURL}/public/statics/js/jquery.fancybox.min.js`} type="text/javascript"></script>
    <script src={`${props.serverURL}/public/statics/js/custom.js`} type="text/javascript"></script>
    <script src={`${props.serverURL}/public/statics/js/index.js`} type="text/javascript"></script>

</body>

</html>
);
};

export default SiteTemplate;